// extracted by mini-css-extract-plugin
module.exports = {"cell":"ReportTable_cell__27HPY","denseCell":"ReportTable_denseCell__1_-VW"};